var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('time',{staticClass:"text-xs text-neutral-7",attrs:{"datetime":_vm.value,"title":_vm.value}},[_vm._v(" "+_vm._s(_vm.formatted)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }